function nianyue(date){
  var now = new Date(date);
  var y = now.getFullYear();
  var m = now.getMonth() + 1;
  var d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m);

}
function day(date){
  var now = new Date(date);
  var y = now.getFullYear();
  var m = now.getMonth() + 1;
  var d = now.getDate();
  return  (d < 10 ? "0" + d : d);
}
export {
  nianyue,
  day
}



//////////////////
// WEBPACK FOOTER
// ./static/public.js
// module id = null
// module chunks = 